var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:['material-icons', { 'icon-button': _vm.type === 'button' }],style:({
    fontSize: _vm.size ? (_vm.size + "px") : '24px',
  }),on:{"click":function($event){$event.stopPropagation();return _vm.$emit('click', $event)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }